/**
 * Created by Fatih on 16.08.2017.
 * Careless whisper
 */

define('casino/providers/CasinoProvider',['jquery'], function($) {
	'use strict';

	function CasinoProvider(casino, gameFunctions) {
		if (!(this instanceof CasinoProvider)) {
			throw new TypeError('CasinoProvider constructor cannot be called as a function.');
		}

		this.casino = casino;
		this.gameFunctions = gameFunctions;
	}

	function addGameInclusionScript(scriptUrl, scriptId, callBack) {
		var script = document.getElementById(scriptId);
		if (script === null) {
			var script = document.createElement('script');
			script.src = scriptUrl;
			script.id = scriptId;
			document.getElementsByTagName('head')[0].appendChild(script);
			if (script.readyState) {
				script.onreadystatechange = function(){
					if (script.readyState === 'loaded' ||
						script.readyState === 'complete') {
						script.onreadystatechange = null;
						if(callBack && typeof (callBack) == "function")
							callBack();
					}
				};
			} else {
				script.onload = function() {
					if(callBack && typeof (callBack) == "function")
						callBack();
				};
			}
		} else {
			if(callBack && typeof (callBack) == "function")
				callBack();
		}
	}

	function getGameData(gameId, gameMode, width, height, callBack) {
		//make a call to new gameloader service
		//get game data

		var postData = {
			gameId: gameId,
			gameMode: gameMode,
			width: width,
			height: height
		};

		$.ajax({
			url: '/pp?flow=8075' + '&gameId=' + postData.gameId + '&gameMode='+postData.gameMode + '&width=' + postData.width + '&height=' + postData.height,
			type: 'GET'
		}).done(function (data) {
			if(callBack && typeof(callBack) == "function")
				callBack(data);
		}).fail(function () {
			console.error('Failed to access GameLoader.');
		});
	}

	function loadNetentGame(params, errMsg) {

		var launchParameters = {
			gameId: params.gameId,
			sessionId: params.sessionId,
			staticServer: params.staticServer,
			gameServer: params.gameServer,
			language: params.language,
			walletMode: 'seamlesswallet',
			targetElement: params.targetElement,
			defaultAudio: true,
			width: params.width,
			height: params.height,
			flashParams: {
				provisionSwfObject: false
			}
		};

		var success = function (netEntExtend) {
		};
		var error = function (error) {
			console.log('Error while loading netent game', error);
		};

		netent.launch(launchParameters, success, error);
	}

	function loadIframeGame(params) {
		var $iframe = $('<iframe>', {
			id: params.id,
			src: params.URL,
			scrolling: 'no',
			width: params.width,
			height: params.height
		});

		$iframe.appendTo(params.$game);

		if(params.callback && typeof (params.callback) == 'function'){
			params.callback();
		}
	}

	function messageEventHandler(options) {
		window.addEventListener('message', function (e) {
			var $gameHolder = options.gameHolder;
			var frameID = 'loaded-game-' + $gameHolder.index();
			var frame = document.getElementById(frameID);
			if (e.data === 'changeForStandart') {
				// When switching back to regular games height and width
				// should be set back to 800x680
				frame.width = '800';
				frame.height = '680';
			} else if (e.data === 'changeForImmersive') {
				// For better user experience height and width should be calculated
				// on operator side to use as much screen space as possible
				// keeping ratio 1920x1080
				frame.width = '1200';
				frame.height = '675';
			} else if (e.data === 'changeForMultiWindow') {
				// For better user experience height and width should be calculated
				// on operator side to use as much screen space as possible
				frame.width = '1200';
				frame.height = '1020';
			}
		}, false);
	}

	function makeEmptyGameDiv($game, targetElementId) {
		$game.empty();
		$('<div>', {
			id: targetElementId
		}).appendTo($game);
	}

	CasinoProvider.prototype = {
		constructor: CasinoProvider,
		getGameData: getGameData,
		makeEmptyGameDiv: makeEmptyGameDiv,
		addGameInclusionScript: addGameInclusionScript,
		loadNetentGame: loadNetentGame,
		loadIframeGame: loadIframeGame,
		messageEventHandler: messageEventHandler
	};

	return CasinoProvider;
});

